import React, { useState, useEffect } from "react";
import "./customCart.css";
import notaryService from "./notaryservice";

function Notary() {
  const [notaryInfo, setNotaryInfo] = useState({
    client_id: "74797",
    product_id: "291053",
    clientFirstName: "",
    clientLastName: "",
    signingStreetAddress: "",
    additionalAddress: "",
    signingCity: "",
    signingState: "AL",
    signingZip: "",
    clientEmail: "",
    clientPhone: "",
    appointmentDate: "",
    appointmentDateTime: "",
    co_signer_first_name: "",
    co_signer_last_name: "",
    co_signer_mobile_phone: "",
    co_signer_email: "",
    signer_language: "",
    owner_email: "",
    specialInstructions: "Scanbacks are required. Leave originals with client.",
  });
  const [isCoSigner, setIsCoSigner] = useState(false);
  const [isLangRequired, setIsLangRequired] = useState(false);
  const [manualEmail, setManualEmail] = useState(false);
  const [newOrder,setNewOrder]=useState({id:"",url:"https://inheritguardnetwork.snapdocs.com/orders/"})
  const clearForm=()=>{
    setNewOrder((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.id = "";
      pd.url=`https://inheritguardnetwork.snapdocs.com/orders/`
      return pd;
    });
    setNotaryInfo({
    client_id: "74797",
    product_id: "291053",
    clientFirstName: "",
    clientLastName: "",
    signingStreetAddress: "",
    additionalAddress: "",
    signingCity: "",
    signingState: "",
    signingZip: "",
    clientEmail: "",
    clientPhone: "",
    appointmentDate: "",
    appointmentDateTime: "",
    co_signer_first_name: "",
    co_signer_last_name: "",
    co_signer_mobile_phone: "",
    co_signer_email: "",
    signer_language: "",
    owner_email: "",
    specialInstructions: "Scanbacks are required. Leave originals with client.",
  });
  }
  const submitForm = async (e) => {
    e.preventDefault();
    const notaryOrderObj = {
      client_id: notaryInfo.client_id,
      product_id: notaryInfo.product_id,
      team_member_id: null,
      appointment_date: notaryInfo.appointmentDate,
      appointment_time: notaryInfo.appointmentDateTime,
      first_name: notaryInfo.clientFirstName,
      last_name: notaryInfo.clientLastName,
      mobile_phone: notaryInfo.clientPhone,
      signer_email: notaryInfo.clientEmail,
      signing_street_address: notaryInfo.signingStreetAddress,
      signing_location_details: notaryInfo.additionalAddress,
      signing_city: notaryInfo.signingCity,
      signing_state: notaryInfo.signingState,
      signing_zip: notaryInfo.signingZip,
      co_signer_first_name: notaryInfo.co_signer_first_name,
      co_signer_last_name: notaryInfo.co_signer_last_name,
      co_signer_mobile_phone: notaryInfo.co_signer_mobile_phone,
      co_signer_email: notaryInfo.co_signer_email,
      owner_email: notaryInfo.owner_email,
      special_instructions: notaryInfo.specialInstructions,
    };
    console.log(notaryOrderObj);
    try{
      let newOrderResponse = await notaryService.createOrder(notaryOrderObj)
      let newOrderId=newOrderResponse.data.order.id
      setNewOrder((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.id = newOrderId;
      pd.url=`https://inheritguardnetwork.snapdocs.com/orders/${newOrderId}`
      return pd;
    });
    }
    catch{
      console.log("failure")
    }
  };
  const onFormFieldChange2 = (event) => {
    const target = event.target;
    let value = target.value;
    let name = target.name;
    setNotaryInfo((prevState) => {
      const pd = {
        ...prevState,
      };
      pd[name] = value;
      return pd;
    });
  };
  const addSigner = () => {
    setIsCoSigner(!isCoSigner);
  };
  const addLanguage = () => {
    setIsLangRequired(!isLangRequired);
  };
  const addEmail = () => {
    setManualEmail(!manualEmail);
    setNotaryInfo((prevState) => {
      const pd = {
        ...prevState,
      };
      pd.owner_email = "";
      return pd;
    });
  };
  return (
    <div id="big-div" style={{ "padding-left": "150px !important" }}>
      <section className="container3 content-section">
        <div class="card" style={{ width: "35%" }}>
          <div class="card-body">
            <form onSubmit={submitForm}>
              <div class="mb-3 col-12">
                <label for="Order Information" class="form-label">
                  Order Information
                </label>
                <select
                  class="form-select"
                  aria-label="Order Information"
                  id="client_id"
                  name="client_id"
                  value={notaryInfo.client_id}
                  onChange={onFormFieldChange2}
                >
                  <option value="74797">Inheritguard</option>
                </select>
              </div>
              <div class="mb-3 col-12">
                <label for="Product Name" class="form-label">
                  Product Name
                </label>
                <select
                  class="form-select"
                  aria-label="Product Name"
                  id="product_id"
                  name="product_id"
                  value={notaryInfo.product_id}
                  onChange={onFormFieldChange2}
                >
                  <option value="291053">Trust Guard Plan (Assisted)</option>
                  <option value="291054">Wealth Guard Plan (Custom)</option>
                </select>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value={isLangRequired}
                  id="flexCheckDefault"
                  onClick={addLanguage}
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Language Required
                </label>
              </div>
              <div className="pt-1">
                {isLangRequired && (
                  <select
                    class="form-select"
                    aria-label="Select Language"
                    id="clientLanguage"
                    name="clientLanguage"
                    value={notaryInfo.clientLanguage}
                    onChange={onFormFieldChange2}
                  >
                    <option value="Afrikaans">Afrikaans</option>
                    <option value="Albanian">Albanian</option>
                    <option value="American Sign Language">
                      American Sign Language
                    </option>
                    <option value="Arabic">Arabic</option>
                    <option value="Armenian">Armenian</option>
                    <option value="Basque">Basque</option>
                    <option value="Bengali">Bengali</option>
                    <option value="Bulgarian">Bulgarian</option>
                    <option value="Catalan">Catalan</option>
                    <option value="Cambodian">Cambodian</option>
                    <option value="Chinese (Mandarin)">
                      Chinese (Mandarin)
                    </option>
                    <option value="Croatian">Croatian</option>
                    <option value="Czech">Czech</option>
                    <option value="Danish">Danish</option>
                    <option value="Dutch">Dutch</option>
                    <option value="English">English</option>
                    <option value="Estonian">Estonian</option>
                    <option value="Fiji">Fiji</option>
                    <option value="Finnish">Finnish</option>
                    <option value="French">French</option>
                    <option value="Georgian">Georgian</option>
                    <option value="German">German</option>
                    <option value="Greek">Greek</option>
                    <option value="Gujarati">Gujarati</option>
                    <option value="Hebrew">Hebrew</option>
                    <option value="Hindi">Hindi</option>
                    <option value="Hungarian">Hungarian</option>
                    <option value="Icelandic">Icelandic</option>
                    <option value="Indonesian">Indonesian</option>
                    <option value="Irish">Irish</option>
                    <option value="Italian">Italian</option>
                    <option value="Japanese">Japanese</option>
                    <option value="Javanese">Javanese</option>
                    <option value="Korean">Korean</option>
                    <option value="Latin">Latin</option>
                    <option value="Latvian">Latvian</option>
                    <option value="Lithuanian">Lithuanian</option>
                    <option value="Macedonian">Macedonian</option>
                    <option value="Malay">Malay</option>
                    <option value="Malayalam">Malayalam</option>
                    <option value="Maltese">Maltese</option>
                    <option value="Maori">Maori</option>
                    <option value="Marathi">Marathi</option>
                    <option value="Mongolian">Mongolian</option>
                    <option value="Nepali">Nepali</option>
                    <option value="Norwegian">Norwegian</option>
                    <option value="Persian">Persian</option>
                    <option value="Polish">Polish</option>
                    <option value="Portuguese">Portuguese</option>
                    <option value="Punjabi">Punjabi</option>
                    <option value="Quechua">Quechua</option>
                    <option value="Romanian">Romanian</option>
                    <option value="Russian">Russian</option>
                    <option value="Samoan">Samoan</option>
                    <option value="Serbian">Serbian</option>
                    <option value="Slovak">Slovak</option>
                    <option value="Slovenian">Slovenian</option>
                    <option value="Spanish">Spanish</option>
                    <option value="Swahili">Swahili</option>
                    <option value="Swedish ">Swedish </option>
                    <option value="Tamil">Tamil</option>
                    <option value="Tatar">Tatar</option>
                    <option value="Telugu">Telugu</option>
                    <option value="Thai">Thai</option>
                    <option value="Tibetan">Tibetan</option>
                    <option value="Tonga">Tonga</option>
                    <option value="Turkish">Turkish</option>
                    <option value="Ukrainian">Ukrainian</option>
                    <option value="Urdu">Urdu</option>
                    <option value="Uzbek">Uzbek</option>
                    <option value="Vietnamese">Vietnamese</option>
                    <option value="Welsh">Welsh</option>
                    <option value="Xhosa">Xhosa</option>
                  </select>
                )}
              </div>
              <h5 className="mt-2">Location and Appointment</h5>
              <div class="mb-3 col-12">
                <input
                  type="text"
                  class="form-control"
                  id="signingStreetAddress"
                  name="signingStreetAddress"
                  value={notaryInfo.signingStreetAddress}
                  onChange={onFormFieldChange2}
                  placeholder="Street Address"
                />
              </div>
              <div class="mb-3 col-12">
                <input
                  type="text"
                  class="form-control"
                  id="additionalAddress"
                  name="additionalAddress"
                  value={notaryInfo.additionalAddress}
                  onChange={onFormFieldChange2}
                  placeholder="Additional Address Info"
                />
              </div>
              <div className="row">
                <div class="mb-3 col-5">
                  <input
                    type="text"
                    class="form-control"
                    id="signingCity"
                    name="signingCity"
                    value={notaryInfo.signingCity}
                    onChange={onFormFieldChange2}
                    placeholder="City"
                  />
                </div>
                <div class="mb-3 col-4">
                  <select
                    class="form-select"
                    aria-label="State"
                    id="signingState"
                    name="signingState"
                    value={notaryInfo.signingState}
                    onChange={onFormFieldChange2}
                  >
                    <option value="AL">Alabama</option>
                    <option value="AK">Alaska</option>
                    <option value="AZ">Arizona</option>
                    <option value="AR">Arkansas</option>
                    <option value="CA">California</option>
                    <option value="CO">Colorado</option>
                    <option value="CT">Connecticut</option>
                    <option value="DE">Delaware</option>
                    <option value="DC">District Of Columbia</option>
                    <option value="FL">Florida</option>
                    <option value="GA">Georgia</option>
                    <option value="HI">Hawaii</option>
                    <option value="ID">Idaho</option>
                    <option value="IL">Illinois</option>
                    <option value="IN">Indiana</option>
                    <option value="IA">Iowa</option>
                    <option value="KS">Kansas</option>
                    <option value="KY">Kentucky</option>
                    <option value="LA">Louisiana</option>
                    <option value="ME">Maine</option>
                    <option value="MD">Maryland</option>
                    <option value="MA">Massachusetts</option>
                    <option value="MI">Michigan</option>
                    <option value="MN">Minnesota</option>
                    <option value="MS">Mississippi</option>
                    <option value="MO">Missouri</option>
                    <option value="MT">Montana</option>
                    <option value="NE">Nebraska</option>
                    <option value="NV">Nevada</option>
                    <option value="NH">New Hampshire</option>
                    <option value="NJ">New Jersey</option>
                    <option value="NM">New Mexico</option>
                    <option value="NY">New York</option>
                    <option value="NC">North Carolina</option>
                    <option value="ND">North Dakota</option>
                    <option value="OH">Ohio</option>
                    <option value="OK">Oklahoma</option>
                    <option value="OR">Oregon</option>
                    <option value="PA">Pennsylvania</option>
                    <option value="RI">Rhode Island</option>
                    <option value="SC">South Carolina</option>
                    <option value="SD">South Dakota</option>
                    <option value="TN">Tennessee</option>
                    <option value="TX">Texas</option>
                    <option value="UT">Utah</option>
                    <option value="VT">Vermont</option>
                    <option value="VA">Virginia</option>
                    <option value="WA">Washington</option>
                    <option value="WV">West Virginia</option>
                    <option value="WI">Wisconsin</option>
                    <option value="WY">Wyoming</option>
                  </select>
                </div>
                <div class="mb-3 col-3">
                  <input
                    type="text"
                    class="form-control"
                    id="signingZip"
                    name="signingZip"
                    value={notaryInfo.signingZip}
                    onChange={onFormFieldChange2}
                    placeholder="Zip"
                  />
                </div>
              </div>
              <div className="row">
                <div class="mb-3 col-6">
                  <input
                    type="date"
                    class="form-control"
                    id="appointmentDate"
                    name="appointmentDate"
                    value={notaryInfo.appointmentDate}
                    onChange={onFormFieldChange2}
                    placeholder="Date"
                  />
                </div>
                <div class="mb-3 col-6">
                  <select
                    className="form-control"
                    id="appointmentDateTime"
                    name="appointmentDateTime"
                    value={notaryInfo.appointmentDateTime}
                    onChange={onFormFieldChange2}
                  >
                    <option value="" label="Time"></option>
                    <option class="" value="asap">
                      ASAP
                    </option>
                    <option class="" value="t_b_d">
                      T.B.D.
                    </option>
                    <option class="" value="morning">
                      Morning
                    </option>
                    <option class="" value="afternoon">
                      Afternoon
                    </option>
                    <option class="" value="evening">
                      Evening
                    </option>
                    <option value="6:00 am">6:00 am</option>
                    <option value="6:15 am">6:15 am</option>
                    <option value="6:30 am">6:30 am</option>
                    <option value="6:45 am">6:45 am</option>
                    <option value="7:00 am">7:00 am</option>
                    <option value="7:15 am">7:15 am</option>
                    <option value="7:30 am">7:30 am</option>
                    <option value="7:45 am">7:45 am</option>
                    <option value="8:00 am">8:00 am</option>
                    <option value="8:15 am">8:15 am</option>
                    <option value="8:30 am">8:30 am</option>
                    <option value="8:45 am">8:45 am</option>
                    <option value="9:00 am">9:00 am</option>
                    <option value="9:15 am">9:15 am</option>
                    <option value="9:30 am">9:30 am</option>
                    <option value="9:45 am">9:45 am</option>
                    <option value="10:00 am">10:00 am</option>
                    <option value="10:15 am">10:15 am</option>
                    <option value="10:30 am">10:30 am</option>
                    <option value="10:45 am">10:45 am</option>
                    <option value="11:00 am">11:00 am</option>
                    <option value="11:15 am">11:15 am</option>
                    <option value="11:30 am">11:30 am</option>
                    <option value="11:45 am">11:45 am</option>
                    <option value="12:00 pm">12:00 pm</option>
                    <option value="12:15 pm">12:15 pm</option>
                    <option value="12:30 pm">12:30 pm</option>
                    <option value="12:45 pm">12:45 pm</option>
                    <option value="1:00 pm">1:00 pm</option>
                    <option value="1:15 pm">1:15 pm</option>
                    <option value="1:30 pm">1:30 pm</option>
                    <option value="1:45 pm">1:45 pm</option>
                    <option value="2:00 pm">2:00 pm</option>
                    <option value="2:15 pm">2:15 pm</option>
                    <option value="2:30 pm">2:30 pm</option>
                    <option value="2:45 pm">2:45 pm</option>
                    <option value="3:00 pm">3:00 pm</option>
                    <option value="3:15 pm">3:15 pm</option>
                    <option value="3:30 pm">3:30 pm</option>
                    <option value="3:45 pm">3:45 pm</option>
                    <option value="4:00 pm">4:00 pm</option>
                    <option value="4:15 pm">4:15 pm</option>
                    <option value="4:30 pm">4:30 pm</option>
                    <option value="4:45 pm">4:45 pm</option>
                    <option value="5:00 pm">5:00 pm</option>
                    <option value="5:15 pm">5:15 pm</option>
                    <option value="5:30 pm">5:30 pm</option>
                    <option value="5:45 pm">5:45 pm</option>
                    <option value="6:00 pm">6:00 pm</option>
                    <option value="6:15 pm">6:15 pm</option>
                    <option value="6:30 pm">6:30 pm</option>
                    <option value="6:45 pm">6:45 pm</option>
                    <option value="7:00 pm">7:00 pm</option>
                    <option value="7:15 pm">7:15 pm</option>
                    <option value="7:30 pm">7:30 pm</option>
                    <option value="7:45 pm">7:45 pm</option>
                    <option value="8:00 pm">8:00 pm</option>
                    <option value="8:15 pm">8:15 pm</option>
                    <option value="8:30 pm">8:30 pm</option>
                    <option value="8:45 pm">8:45 pm</option>
                    <option value="9:00 pm">9:00 pm</option>
                    <option value="9:15 pm">9:15 pm</option>
                    <option value="9:30 pm">9:30 pm</option>
                    <option value="9:45 pm">9:45 pm</option>
                    <option value="10:00 pm">10:00 pm</option>
                    <option value="10:15 pm">10:15 pm</option>
                    <option value="10:30 pm">10:30 pm</option>
                    <option value="10:45 pm">10:45 pm</option>
                    <option value="11:00 pm">11:00 pm</option>
                    <option value="11:15 pm">11:15 pm</option>
                    <option value="11:30 pm">11:30 pm</option>
                    <option value="11:45 pm">11:45 pm</option>
                    <option value="12:00 am">12:00 am</option>
                    <option value="12:15 am">12:15 am</option>
                    <option value="12:30 am">12:30 am</option>
                    <option value="12:45 am">12:45 am</option>
                    <option value="1:00 am">1:00 am</option>
                    <option value="1:15 am">1:15 am</option>
                    <option value="1:30 am">1:30 am</option>
                    <option value="1:45 am">1:45 am</option>
                    <option value="2:00 am">2:00 am</option>
                    <option value="2:15 am">2:15 am</option>
                    <option value="2:30 am">2:30 am</option>
                    <option value="2:45 am">2:45 am</option>
                    <option value="3:00 am">3:00 am</option>
                    <option value="3:15 am">3:15 am</option>
                    <option value="3:30 am">3:30 am</option>
                    <option value="3:45 am">3:45 am</option>
                    <option value="4:00 am">4:00 am</option>
                    <option value="4:15 am">4:15 am</option>
                    <option value="4:30 am">4:30 am</option>
                    <option value="4:45 am">4:45 am</option>
                    <option value="5:00 am">5:00 am</option>
                    <option value="5:15 am">5:15 am</option>
                    <option value="5:30 am">5:30 am</option>
                    <option value="5:45 am">5:45 am</option>
                  </select>
                  {/* <input
                    type="text"
                    class="form-control"
                    id="appointmentDateTime"
                    name="appointmentDateTime"
                    value={notaryInfo.appointmentDateTime}
                    onChange={onFormFieldChange2}
                    placeholder="Time"
                  /> */}
                </div>
              </div>

              <h5 className="mt-2">Signer</h5>
              <div className="row">
                <div class="mb-3 col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="clientFirstName"
                    name="clientFirstName"
                    value={notaryInfo.clientFirstName}
                    onChange={onFormFieldChange2}
                    placeholder="First Name"
                  />
                </div>
                <div class="mb-3 col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="clientLastName"
                    name="clientLastName"
                    value={notaryInfo.clientLastName}
                    onChange={onFormFieldChange2}
                    placeholder="Last Name"
                  />
                </div>
              </div>

              <div className="row">
                <div class="mb-3 col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="clientPhone"
                    name="clientPhone"
                    value={notaryInfo.clientPhone}
                    onChange={onFormFieldChange2}
                    placeholder="Cell phone"
                  />
                </div>
                <div class="mb-3 col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="clientEmail"
                    name="clientEmail"
                    value={notaryInfo.clientEmail}
                    onChange={onFormFieldChange2}
                    placeholder="Email address"
                  />
                </div>
              </div>

              {!isCoSigner && (
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={addSigner}
                  style={{ "text-decoration": "none" }}
                >
                  +Add Signer
                </button>
              )}
              {isCoSigner && (
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={addSigner}
                  style={{ "text-decoration": "none" }}
                >
                  Remove
                </button>
              )}
              {isCoSigner && (
                <>
                  <div className="row">
                    <div class="mb-3 col-6">
                      <input
                        type="text"
                        class="form-control"
                        id="co_signer_first_name"
                        name="co_signer_first_name"
                        value={notaryInfo.co_signer_first_name}
                        onChange={onFormFieldChange2}
                        placeholder="First Name"
                      />
                    </div>
                    <div class="mb-3 col-6">
                      <input
                        type="text"
                        class="form-control"
                        id="co_signer_last_name"
                        name="co_signer_last_name"
                        value={notaryInfo.co_signer_last_name}
                        onChange={onFormFieldChange2}
                        placeholder="Last Name"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div class="mb-3 col-6">
                      <input
                        type="text"
                        class="form-control"
                        id="co_signer_mobile_phone"
                        name="co_signer_mobile_phone"
                        value={notaryInfo.co_signer_mobile_phone}
                        onChange={onFormFieldChange2}
                        placeholder="Cell phone"
                      />
                    </div>
                    <div class="mb-3 col-6">
                      <input
                        type="text"
                        class="form-control"
                        id="co_signer_email"
                        name="co_signer_email"
                        value={notaryInfo.co_signer_email}
                        onChange={onFormFieldChange2}
                        placeholder="Email address"
                      />
                    </div>
                  </div>
                </>
              )}
              <div class="mb-3 col-12">
                <label for="Special Instructions" class="form-label">
                 Special Instructions
                </label>
                <input
                  type="text-area"
                  class="form-control"
                  id="specialInstructions"
                  name="specialInstructions"
                  value={notaryInfo.specialInstructions}
                  onChange={onFormFieldChange2}
                  placeholder="Special Instructions"
                />
              </div>
              <div class="mb-3 col-12">
                <label for="Your Email" class="form-label">
                  Your Email
                </label>
                {!manualEmail && (
                  <select
                    class="form-select"
                    aria-label="owner_email"
                    id="owner_email"
                    name="owner_email"
                    value={notaryInfo.owner_email}
                    onChange={onFormFieldChange2}
                  >
                    <option value="">Select Below</option>
                    <option value="christy@ignplan.com">
                      christy@ignplan.com
                    </option>
                    <option value="melissa@ignplan.com">
                      melissa@ignplan.com
                    </option>
                    <option value="augusto@ignplan.com">
                      augusto@ignplan.com
                    </option>
                  </select>
                )}

                {manualEmail && (
                  <input
                    type="text"
                    class="form-control"
                    id="owner_email"
                    name="owner_email"
                    value={notaryInfo.owner_email}
                    onChange={onFormFieldChange2}
                    placeholder="Your Email"
                  />
                )}
                <button
                  type="button"
                  className="btn btn-link"
                  onClick={addEmail}
                  style={{ "text-decoration": "none" }}
                >
                  {manualEmail ? "Select From List" : "Add Your Email Manually"}
                </button>
              </div>
              <div>
                <button type="submit" class="btn btn-success">
                  Create Order and Start Search
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
   
      {        newOrder.id &&<div>
        <a target="_blank" href={newOrder.url}><button className="ms-4 btn btn-primary">New Order for {notaryInfo.clientFirstName} {notaryInfo.clientLastName}</button></a>
        <button className="ms-4 btn btn-danger" onClick={clearForm}>Create New Order</button>
      </div>}
    </div>
  );
}

export default Notary;
